import { useQuery } from '@tanstack/react-query';
import { categoryService } from '../services/categoryService';

export const useCategories = (accountId?: string) => {
  return useQuery({
    queryKey: ['categories', accountId],
    queryFn: () => categoryService.getCategories(),
  });
};

export const useCategoriesWithGroups = (accountId?: string) => {
  return useQuery({
    queryKey: ['categories', 'groups', accountId],
    queryFn: () => categoryService.getCategoriesWithGroups(),
  });
};

